import MainContainer from "../../components/container/MainContainer";

const Pledge = () => {
  return (
    <MainContainer>
      <div className="flex items-center justify-between my-3">
        <h4 className="">Pledges</h4>
      </div>
      <main className="table-container">
        <div className="w-full h-full flex justify-center items-center">
          <h4 className="text-text-1/60">No Pledges Added yet... </h4>
        </div>
      </main>
    </MainContainer>
  );
};

export default Pledge;
